import { render, staticRenderFns } from "./publicTop.vue?vue&type=template&id=8c4acbac&scoped=true&"
import script from "./publicTop.vue?vue&type=script&lang=js&"
export * from "./publicTop.vue?vue&type=script&lang=js&"
import style0 from "./publicTop.vue?vue&type=style&index=0&id=8c4acbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4acbac",
  null
  
)

export default component.exports